import {CbJsonSalvusCalendar,} from "@/api/pharma-cms-content-block/models";
import {NormalContentBlockModel} from "@/models/api/pharma-cms-content-block/NormalContentBlockModel";
import {CalendarWidgetVersionEnum} from "@/api/enums/calendar-widget-version-enum";
import {SalvusAppointmentTypesToShowEnum} from "@/api/enums/salvus-appointment-types-to-show-enum";

export class CbJsonSalvusCalendarModel extends NormalContentBlockModel implements CbJsonSalvusCalendar {
    appointment_types_to_show_code: SalvusAppointmentTypesToShowEnum;
    salvus_pharmacy_code?: string | null;
    apb_number: string;
    appointment_identifiers?: string[] | null;
    calendar_widget_version: CalendarWidgetVersionEnum;
    is_field_visible_dob: boolean;
    is_field_required_dob: boolean;
    is_field_visible_email: boolean;
    is_field_required_email: boolean;
    is_field_visible_gender: boolean;
    is_field_required_gender: boolean;
    is_field_visible_phone: boolean;
    is_field_required_phone: boolean;
    is_field_visible_postal_code: boolean;
    is_field_required_postal_code: boolean;
    is_consent_required: boolean;

    constructor() {
        super();
        this.appointment_types_to_show_code = SalvusAppointmentTypesToShowEnum.ALL_AVAILABLE;
        this.salvus_pharmacy_code = null;
        this.apb_number = '';
        this.appointment_identifiers = [];
        this.calendar_widget_version = CalendarWidgetVersionEnum.v3;
        this.is_field_visible_gender = false;
        this.is_field_required_gender = false;
        this.is_field_visible_email = true;
        this.is_field_required_email = true;
        this.is_field_visible_dob = true;
        this.is_field_required_dob = false;
        this.is_field_visible_phone = true;
        this.is_field_required_phone = false;
        this.is_field_visible_postal_code = false;
        this.is_field_required_postal_code = false;
        this.is_consent_required = true;
    }

    public static createWithDefaults(): CbJsonSalvusCalendarModel {
        return new this();
    }
}
